<template>
  <div>
    <b-card title="" class="title-inline">
      <b-card-text class="newyear">
        <p v-if="!currentOs">
          Twoje zaufanie dopinguje nas do szukania nowych, jak najbardziej
          dogodnych rozwiązań. Stale pracujemy dla Ciebie zbierając uwagi i
          śledząc aktualne warunki prawne. W ślad za tym aktualizujemy i
          rozwijamy nasz program. Poniżej informacje pomocne przy zmianie roku.
        </p>
        <div
          v-if="!currentOs"
          class="accordion order-card"
          role="tablist"
          id="eaktu"
        >
          <b-card no-body class="mb-2 noborder-card">
            <b-card-header
              header-tag="header"
              class="p-0 mb-2 font-weight-bold h6"
              role="tab"
            >
              <span>e-aktualizacja</span>
              <span v-b-toggle.eaktuToggle>
                <span class="when-closed px-2">
                  <i class="fas fa-chevron-down"></i>
                </span>
                <span class="when-open px-2">
                  <i class="fas fa-chevron-up when-open"></i>
                </span>
              </span>
            </b-card-header>
            <b-card-body>
              <b-collapse id="eaktuToggle" accordion="eaktu" role="tabpanel">
                <b-card-text>
                  <p>
                    Składając zamówienie na Opiekę Serwisową i aktualizację
                    dostępny jest całkowicie zautomatyzowany sposób obsługi -
                    wystarczy na kroku Dostawa i płatność wybrać dostawę online
                    i płatność PayU.
                  </p>
                  <ul class="list-big">
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Dzięki temu
                      <strong>wersja startowa programu na nowy rok</strong>
                      znajdzie się na Twoim komputerze
                      <strong>już w kilka minut !</strong>
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Zapłata za aktualizację zostanie pobrana przez
                      <strong>system PayU.pl</strong> (karta lub przelewy
                      online), a faktura będzie dostępna w formacie pdf.
                    </li>
                  </ul>
                </b-card-text>
              </b-collapse>
            </b-card-body>
          </b-card>
        </div>
        <div
          class="accordion order-card"
          role="tablist"
          id="cd"
          v-if="!currentOs"
        >
          <b-card no-body class="mb-2 noborder-card">
            <b-card-header
              header-tag="header"
              class="p-0 mb-2 font-weight-bold h6"
              role="tab"
            >
              <span>Wersja programu na CD</span>
              <span v-b-toggle.cdToggle>
                <span class="when-closed px-2">
                  <i class="fas fa-chevron-down"></i>
                </span>
                <span class="when-open px-2">
                  <i class="fas fa-chevron-up when-open"></i>
                </span>
              </span>
            </b-card-header>
            <b-card-body>
              <b-collapse id="cdToggle" accordion="cd" role="tabpanel">
                <b-card-text>
                  <p>
                    Jeśli chcesz mieć CD z wersją instalacyjną programu na nowy
                    rok nie trzeba już jej zamawiać. Nadal wystarczy
                    e-aktualizacja, gdyż program zawiera opcję:
                    <strong class="font-italic">
                      Utwórz wersję instalacyjną</strong
                    >. Wersję tę możesz nagrać na CD, na pendrive lub na dysk.
                    Instrukcja dostępna w artykule:
                    <a :href="aktLink" target="_blank">
                      Aktualizacja programu na nowy rok >
                    </a>
                  </p>
                  <p class="mt-2">
                    Nadal pozostawiamy możliwość zamówienia tradycyjnej wersji
                    na CD, ale tylko w przypadku wersji programu na nowy rok
                    (dodatkowo płatna wysyłka Poczta Polska/Kurier). Zamówienia
                    będą realizowane sukcesywnie w kolejności nadchodzących
                    zgłoszeń.
                  </p>
                  <p class="mt-2">
                    Szczegółowe wyjaśnienia na temat zmiany roku znajdują się w
                    artykule:
                    <a :href="changeYearLink" target="_blank">
                      Zmiana roku w programie ></a
                    >
                  </p>
                </b-card-text>
              </b-collapse>
            </b-card-body>
          </b-card>
        </div>

        <!-- TEXT -->
        <div class="accordion order-card" role="tablist" id="whatsNew">
          <b-card no-body class="mb-2 noborder-card">
            <b-card-header
              header-tag="header"
              class="p-0 mb-2 font-weight-bold h6"
              role="tab"
            >
              <span>
                Zmiany w najnowszych wersjach oraz plany na rok {{ year }}
              </span>
              <span v-b-toggle.whatsNewToggle>
                <span class="when-closed px-2">
                  <i class="fas fa-chevron-down"></i>
                </span>
                <span class="when-open px-2">
                  <i class="fas fa-chevron-up when-open"></i>
                </span>
              </span>
            </b-card-header>
            <b-card-body>
              <b-collapse
                id="whatsNewToggle"
                accordion="whatsNew"
                role="tabpanel"
                visible
              >
                <b-card-text v-if="program === 'skp'">
                  <ul class="list-big">
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Metoda kasowa rozliczanie podatku dochodowego
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Zmiany w składce zdrowotnej dla przedsiębiorców - 
                      zmniejszenie od 2025 r. minimalnej podstawy wymiaru
                      składki do 75 proc. minimalnego wynagrodzenia oraz  z
                      uwzględnieniem kasowego rozliczenia PIT.
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Nowe zestawienia przychodów i rozchodów, podatku
                      dochodowego.
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Automatyczne rozliczanie różnic kursowych.
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Import z pliku JPK_FA dokumentów do VAT-OSS.
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Pobieranie danych kontrahenta zagranicznego z VIES.
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Eksport kartoteki środków trwałych do pliku Excela .
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Możliwość wydruku grupy faktur z Archiwum faktur.
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Wprowadzenie testowej wersji nowego sposobu wystawiania
                      faktur oraz odbierania dokumentów zakupowych przez Krajowy
                      System e-Faktur (KSeF), poprzez umożliwienie:
                      <ul class="greenBig">
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          Testowej wysyłki faktur wprost z programu SKP<sup
                            >®</sup
                          >
                          do KSeF
                        </li>
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          Testowego pobierania faktur zakupowych z KSeF i
                          zaksięgowania ich w SKP<sup>®</sup><br />
                          <a
                            href="https://www.ksiega-podatkowa.pl/ksef"
                            target="_blank"
                            >Czytaj więcej o KSeF w SKP<sup>®</sup></a
                          >
                        </li>
                      </ul>
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Nowe parametry w roku 2025:
                      <ul class="greenBig">
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          kwota limitu 30-krotności ograniczenia składek ZUS –
                          260 190 zł
                        </li>
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          prognozowane przeciętne wynagrodzenie – 8 673 zł
                          (prognoza)
                        </li>
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          najniższa krajowa – 4 666 zł
                        </li>
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          współczynnik ekwiwalentu – 20,83 zł
                        </li>
                      </ul>
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Stała aktualizacja zasad księgowych oraz deklaracji i
                      e-deklaracji.
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Realizacja w ciągu roku innych zmian w programie zgodnie z
                      postulatami Klientów.
                    </li>
                  </ul>
                </b-card-text>
                <b-card-text v-if="program === 'sam'">
                  <ul class="list-big">
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Dostosowanie do nowych regulacji w zakresie „Polskiego
                      ładu”:
                      <ul class="greenBig">
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          Wyliczanie podatku dochodowego PIT według nowej skali
                          podatkowej wraz z uwzględnieniem nowej kwoty
                          zmniejszającej podatek (rocznie: 5 100 zł)
                        </li>
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          Wyliczanie i uwzględnienie tzw. ulgi dla „klasy
                          średniej”
                        </li>
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          Nowy wymiar składki zdrowotnej oraz likwidacja
                          możliwości jej odliczenia od podatku
                        </li>
                        <li>
                          <img
                            :src="styles.check_circle"
                            alt="check"
                            class="mb-1"
                            style="max-width: 12px"
                          />
                          Obsługa nowych zwolnień od podatku PIT:
                          <ul class="greenBig">
                            <li>
                              <img
                                :src="styles.check_circle"
                                alt="check"
                                class="mb-1"
                                style="max-width: 12px"
                              />
                              dla rodziców wychowujących minimum 4 dzieci
                            </li>
                            <li>
                              <img
                                :src="styles.check_circle"
                                alt="check"
                                class="mb-1"
                                style="max-width: 12px"
                              />
                              dla pracujących osób powyżej 60 r. życia
                            </li>
                            <li>
                              <img
                                :src="styles.check_circle"
                                alt="check"
                                class="mb-1"
                                style="max-width: 12px"
                              />
                              dla podatnika, który przeniósł miejsce
                              zamieszkania na terytorium RP (ulga na powrót)
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Zmiany w zakresie stawek Ryczałtu Ewidencjonowanego (nowe
                      stawki 12% i 14% wraz z nowym wzorem ewidencji)
                    </li>
                    <li v-if="program === 'skp'">
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Obsługa nowej struktury pliku JPK_V7M i JPK_V7K
                    </li>
                    <li v-if="program === 'skp'">
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Nowe wzory deklaracji ZUS DRA i ZUS RCA wraz z nowym
                      przesyłam do Płatnika, likwidacja ZUS RZA
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Stała aktualizacja zasad księgowych oraz deklaracji i
                      e-deklaracji
                    </li>
                    <li>
                      <img :src="styles.check" alt="check" class="mb-1" />
                      Realizacja w ciągu roku innych zmian w programie zgodnie z
                      postulatami klientów
                    </li>
                  </ul>
                </b-card-text>
              </b-collapse>
            </b-card-body>
          </b-card>
        </div>
        <p>
          <strong
            >Śledź zmiany w programie (obecne i we wcześniejszych wersjach) w
            <a
              href="https://www.ksiega-podatkowa.pl/historia-wersji"
              target="_blank"
              >Historii zmian >
            </a>
          </strong>
        </p>
        <p class="td-right font-italic">
          Z poważaniem,<br />Zespół FORMSOFT sp. z o.o.
        </p>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NewYear',
  props: {
    styles: {},
  },
  data() {
    return {
      year: process.env.MIX_AKTU_YEAR,
    };
  },
  created() {
    this.$store.commit('order/resetOrder');
    this.$store.commit('order/resetSteps');
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      client: 'auth/client',
      currentOs: 'auth/currentOs',
    }),
    aktLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/akademia-skp/aktualizacja-programu'
        : 'https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/aktualizacja-programu';
    },
    changeYearLink() {
      if (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('S')
      ) {
        return 'https://www.ksiega-podatkowa.pl/akademia-skp/zmiana-roku-wersja-sieciowa';
      } else {
        return this.program === 'skp'
          ? 'https://www.ksiega-podatkowa.pl/akademia-skp/zmiana-roku'
          : 'https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/zmiana-roku';
      }
    },
  },
  methods: {
    getClient() {
      axios
        .get('/api/getClient/' + this.program)
        .then(({ data }) => {
          this.client = data;
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 419) {
            this.$store.dispatch('auth/me');
            this.$router.push({ name: 'Login' });
          }
        });
    },
  },
};
</script>

<style scoped>
.card {
  border-bottom: 0 !important;
}
</style>
